import clearLocalStorage from './clearLocalStorage';
import { proxyUrl } from './http';

const logout = () => {
  clearLocalStorage();
  window.location.href = `${proxyUrl}/logout`;
};

export default logout;
